import { z } from "zod";

const STABLE_ID_PATTERN = /^[a-z][a-z0-9]*(?:[._-][a-z0-9]+)*$/;
const LAND_TYPE_ID_PATTERN = /^[a-z][a-z0-9]*(?:-[a-z0-9]+)*$/;
const SEMANTIC_VERSION_PATTERN =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?(?:\+[0-9A-Za-z-]+(?:\.[0-9A-Za-z-]+)*)?$/;

export const SCHEMA_VERSION = 1 as const;

export const StableIdSchema = z
  .string()
  .min(3)
  .max(100)
  .regex(
    STABLE_ID_PATTERN,
    "must be a lowercase stable ID using letters, numbers, '.', '_' or '-'",
  );

export const CardDefinitionIdSchema = StableIdSchema.brand<"CardDefinitionId">();
export const LandTypeIdSchema = z
  .string()
  .min(1)
  .max(64)
  .regex(
    LAND_TYPE_ID_PATTERN,
    "must be a lowercase kebab-case Land Type ID using letters, numbers and hyphens",
  )
  .brand<"LandTypeId">();
export const EffectDefinitionIdSchema = StableIdSchema.brand<"EffectDefinitionId">();
export const ConditionDefinitionIdSchema = StableIdSchema.brand<"ConditionDefinitionId">();
export const TriggerDefinitionIdSchema = StableIdSchema.brand<"TriggerDefinitionId">();
export const MandateIdSchema = StableIdSchema.brand<"MandateId">();
export const DeckDefinitionIdSchema = StableIdSchema.brand<"DeckDefinitionId">();
export const PresentationAssetIdSchema = StableIdSchema.brand<"PresentationAssetId">();

export const SemanticVersionSchema = z
  .string()
  .regex(SEMANTIC_VERSION_PATTERN, "must be a semantic version such as 1.0.0");

export const DefinitionVersionSchema = z.number().int().positive();
export const NonNegativeIntegerSchema = z.number().int().nonnegative();
export const PositiveIntegerSchema = z.number().int().positive();

export type CardDefinitionId = z.infer<typeof CardDefinitionIdSchema>;
export type ConditionDefinitionId = z.infer<typeof ConditionDefinitionIdSchema>;
export type DeckDefinitionId = z.infer<typeof DeckDefinitionIdSchema>;
export type EffectDefinitionId = z.infer<typeof EffectDefinitionIdSchema>;
export type MandateId = z.infer<typeof MandateIdSchema>;
export type LandTypeId = z.infer<typeof LandTypeIdSchema>;
export type PresentationAssetId = z.infer<typeof PresentationAssetIdSchema>;
export type SemanticVersion = z.infer<typeof SemanticVersionSchema>;
export type TriggerDefinitionId = z.infer<typeof TriggerDefinitionIdSchema>;
